module.exports = __webpack_public_path__ + "img/multiplier_free_2.0e915625.png";